var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 60,
    viewBox: "0 0 40 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1486 14.9576C15.7323 18.6531 12.6164 21.6843 9.8491 25.169C9.55698 25.5368 1.47374 35.4322 5.24311 33.3381C8.42946 31.5679 12.2984 32.1649 15.8021 32.1649C19.2808 32.1649 20.6732 29.9796 18.5396 33.7726C15.0395 39.9951 10.0776 44.9787 5.72109 50.5454C5.34963 51.02 1.14138 57.6419 2.15797 57.9323C4.39504 58.5715 11.602 50.6371 13.0646 49.3721C19.3384 43.9462 25.3724 38.1948 31.4451 32.556C32.2924 31.7692 39.0797 23.722 38.3106 22.9529C36.9318 21.574 29.1646 23.489 27.5343 23.7351C25.3154 24.07 19.473 26.402 21.1033 22.7791C22.849 18.8998 23.2596 14.0226 24.2319 9.9171C24.8185 7.44034 26.88 0.140224 25.7962 2.44323C22.767 8.88027 18.0943 14.6479 14.2378 20.4326",
    stroke: "#2F2F37",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.82aa13c5ee2e780f4b60e341cb9b1876.svg";
export { ForwardRef as ReactComponent };